/**
 * Cart rebuild deep links, for abandoned-cart emails (Klaviyo).
 *
 *   https://tryzalt.com/?zalt_cart=VARIANT:QTY[:PLAN][:b],VARIANT:QTY...
 *
 *   VARIANT  numeric variant id (required)
 *   QTY      quantity (defaults to 1, capped at 10)
 *   PLAN     optional: a numeric selling plan id, or the token `s`
 *            meaning "this variant's default subscription plan" looked
 *            up from the cart drawer's upsell map. Omitted = one-time.
 *            Emails default to one-time on purpose: the Klaviyo Added
 *            to Cart event carries no plan info, and rebuilding as a
 *            surprise subscription would be worse than the drawer's
 *            visible Upgrade button.
 *   b        optional: mark the line _bogo (drawer suppresses its
 *            subscribe upsell, same as a buy-box BOGO add).
 *
 * Behavior: REPLACES the cart (clear, then one add.js call with all
 * lines), strips the param from the URL so back/refresh can't re-clear,
 * then opens the drawer. Subscription lines get Skio's dynamic-box
 * properties (same fetch as the drawer's upgrade flow) so the resulting
 * contract stays portal-editable.
 */
(function () {
  'use strict';

  var m = /[?&]zalt_cart=([^&]+)/.exec(window.location.search);
  if (!m) return;

  var upsell = null;
  try {
    var el = document.querySelector('[data-cart-upsell-json]');
    if (el) upsell = JSON.parse(el.textContent);
  } catch (e) { /* map unavailable; `s` tokens fall back to one-time */ }

  var items = [];
  decodeURIComponent(m[1]).split(',').slice(0, 20).forEach(function (spec) {
    var seg = spec.split(':');
    var id = parseInt(seg[0], 10);
    if (!id) return;
    var qty = parseInt(seg[1], 10);
    var item = { id: id, quantity: Math.min(Math.max(qty || 1, 1), 10) };
    seg.slice(2).forEach(function (f) {
      if (f === 'b') {
        item.properties = item.properties || {};
        item.properties._bogo = '2-for-1';
      } else if (f === 's') {
        var entry = upsell && upsell.variants && upsell.variants[String(id)];
        if (entry && entry.sellingPlanId) item.selling_plan = entry.sellingPlanId;
      } else if (/^\d+$/.test(f)) {
        item.selling_plan = parseInt(f, 10);
      }
    });
    items.push(item);
  });
  if (items.length === 0) return;

  // Strip the param before any cart mutation so refresh/back/share of the
  // landed URL can never wipe a cart again.
  try {
    var url = new URL(window.location.href);
    url.searchParams.delete('zalt_cart');
    window.history.replaceState({}, '', url.toString());
  } catch (e) { /* ancient browser: param stays; rebuild is idempotent enough */ }

  var needsBox = items.some(function (i) { return i.selling_plan; });
  var boxPid = upsell && upsell.skioDynamicBoxProductId;
  var boxPromise = needsBox && boxPid
    ? fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productPlatformId: String(boxPid) })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) {
          var box = json && (json.DynamicBox || json.dynamicBox);
          return box && box.boxId ? box.boxId : null;
        })
        .catch(function () { return null; })
    : Promise.resolve(null);

  function openDrawer(attempt) {
    if (window.ZaltCart && typeof window.ZaltCart.open === 'function') {
      window.ZaltCart.open(); // open() refetches the cart itself
      return;
    }
    if (attempt < 10) {
      setTimeout(function () { openDrawer(attempt + 1); }, 150);
      return;
    }
    window.location.href = '/cart';
  }

  boxPromise
    .then(function (boxId) {
      if (boxId) {
        items.forEach(function (i) {
          if (!i.selling_plan) return;
          i.properties = i.properties || {};
          i.properties._dynamicBoxId = boxId;
          i.properties._dynamicBoxIndex = 0;
        });
      }
      return fetch('/cart/clear.js', { method: 'POST' });
    })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart rebuild add failed: ' + r.status);
      openDrawer(0);
    })
    .catch(function (err) {
      console.warn('zalt_cart rebuild failed', err);
    });
})();
